import React, { useState, useEffect } from 'react';
import { Upload, message } from 'antd';
import ImgCrop from 'antd-img-crop';
import { PlusOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const StyledUpload = styled(Upload)`
  .ant-upload-select {
    width: 100% !important;
    height: ${props => props.$height || 200}px !important;
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-upload-list-item-container {
    width: 100% !important;
    height: ${props => props.$height || 200}px !important;
  }

  img {
    object-fit: cover;
  }
`;

const UploadButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;

  .anticon {
    font-size: 32px;
    margin-bottom: 8px;
  }
`;

export default function  ImageCropUpload({
  value,
  onChange,
  aspect = 16 / 9,
  height = 200,
  maxSize = 5, // MB
  acceptedFormats = ['image/jpeg', 'image/png', 'image/webp'],
  cropShape = 'rect', // 'rect' ou 'round'
  quality = 0.8,
  rotationSlider = false,
  showGrid = true,
  modalTitle = 'Ajustar imagem',
  modalOk = 'Confirmar',
  modalCancel = 'Cancelar',
  placeholder = 'Upload',
  disabled = false,
  ...props
}){
  const [fileList, setFileList] = useState([]);

  // Sincroniza o fileList com o value externo
  useEffect(() => {
    if (value) {
      if (typeof value === 'string') {
        // É uma URL
        setFileList([{ uid: '-1', url: value, status: 'done' }]);
      }

      // else if (value.file) {
      //     console.log(value)
      //   // Já tem um arquivo
      //   setFileList([{ uid: '-1', url: value.preview, originFileObj: value.file, status: 'done' }]);
      // }
    } else {
      setFileList([]);
    }
  }, [value]);

  const beforeUpload = (file) => {
    const isValidFormat = acceptedFormats.includes(file.type);
    if (!isValidFormat) {
      message.error(`Formato não suportado. Use: ${acceptedFormats.join(', ')}`);
      return Upload.LIST_IGNORE;
    }

    const isValidSize = file.size / 1024 / 1024 < maxSize;
    if (!isValidSize) {
      message.error(`A imagem deve ter menos de ${maxSize}MB`);
      return Upload.LIST_IGNORE;
    }

    return true;
  };

  const handleChange = async ({ fileList: newFileList }) => {
    setFileList(newFileList);

    if (newFileList.length > 0 && newFileList[0].originFileObj) {
      const file = newFileList[0].originFileObj;
      // Cria preview para exibição
      const preview = URL.createObjectURL(file);
      // Retorna objeto com file e preview para o form
      onChange?.({ file, preview });
    } else if (newFileList.length === 0) {
      onChange?.(null);
    }
  };

  const uploadButton = (
    <UploadButton>
      <PlusOutlined />
      <span>{placeholder}</span>
    </UploadButton>
  );

  return (
    <ImgCrop
      aspect={aspect}
      quality={quality}
      rotationSlider={rotationSlider}
      showGrid={showGrid}
      shape={cropShape}
      modalTitle={modalTitle}
      modalOk={modalOk}
      modalCancel={modalCancel}

    >
      <StyledUpload
        {...props}
        $height={height}
        listType="picture-card"
        fileList={fileList}
        onChange={handleChange}
        beforeUpload={beforeUpload}
        maxCount={1}
        disabled={disabled}
        customRequest={({ onSuccess }) => {
          setTimeout(() => onSuccess('ok'), 0);
        }}
        {...props}
      >
        {fileList.length < 1 && uploadButton}
      </StyledUpload>
    </ImgCrop>
  );
};
